import "./Footer.scss";
// REACT, ROUTER & REDUX
import React from "react";
import { NavLink } from "react-router-dom";

// SVG & IMAGES
import calcImg from "../../img/header-calculator.svg";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__brand">
        <img src={calcImg} alt="" />
        <div>
          <strong>Engineering Calculator</strong>
          <p>Practical tools and reference data for everyday engineering.</p>
        </div>
      </div>
      <nav aria-label="Footer navigation">
        <NavLink to="/">Home</NavLink>
        <NavLink to="/calculator">Calculators</NavLink>
        <NavLink to="/catalogue">Catalogue</NavLink>
      </nav>
      <p className="footer__copyright">
        © {new Date().getFullYear()} AMENG AB. All rights reserved.
      </p>
    </footer>
  );
}
